import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { reloadForNewVersion } from './app/chunkReload';
import './styles/fonts.css';
import './styles/global.css';
import './styles/operations.css';
import './styles/communication.css';
import './styles/documents.css';

// Programmteil der alten Version nach einem Deployment nicht mehr vorhanden: neu laden statt Fehlerseite.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForNewVersion()) event.preventDefault();
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
